import { HookOutOfContextError } from "@jugl-web/utils";
import { useContext } from "react";
import { OverlayQueueContext } from "./OverlayQueueContext";

export const useOverlayQueueContext = () => {
  const context = useContext(OverlayQueueContext);

  if (!context) {
    throw new HookOutOfContextError(
      "useOverlayQueueContext",
      "OverlayQueueContext"
    );
  }

  return context;
};
